// API Service for communicating with the backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cornblissbackend-arerbqbwc5cmcufh.canadacentral-01.azurewebsites.net/api';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7058/api';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cornblissbackend-arerbqbwc5cmcufh.canadacentral-01.azurewebsites.net/api';

export const apiService = {
  // Orders API endpoints gg 
  getOrders: async (limit) => {
    try {
      const url = new URL(`${API_BASE_URL}/Orders`);
      if (limit) url.searchParams.append('limit', limit);
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch orders');
      return await response.json();
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  getOrder: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Orders/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch order');
      return await response.json();
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  },

  createOrder: async (orderData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
      if (!response.ok) throw new Error('Failed to create order');
      return await response.json();
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  updateOrder: async (id, orderData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Orders/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
      if (!response.ok) throw new Error('Failed to update order');
      return await response.json();
    } catch (error) {
      console.error('Error updating order:', error);
      throw error;
    }
  },

  deleteOrder: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Orders/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to delete order');
      // 204 No Content returns no body, so don't try to parse JSON
      if (response.status === 204) {
        return { success: true };
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting order:', error);
      throw error;
    }
  },

  updateBooking: async (id, bookingData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/bookings/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData),
      });
      if (!response.ok) throw new Error('Failed to update booking');
      return await response.json();
    } catch (error) {
      console.error('Error updating booking:', error);
      throw error;
    }
  },

  deleteBooking: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/bookings/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to delete booking');
      return await response.json();
    } catch (error) {
      console.error('Error deleting booking:', error);
      throw error;
    }
  },

  validateBooking: async (bookingData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/bookings/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData),
      });
      if (!response.ok) throw new Error('Failed to validate booking');
      return await response.json();
    } catch (error) {
      console.error('Error validating booking:', error);
      throw error;
    }
  },

  // Stock API endpoints
  getAllStocks: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch stocks');
      return await response.json();
    } catch (error) {
      console.error('Error fetching stocks:', error);
      throw error;
    }
  },

  getStockById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch stock');
      return await response.json();
    } catch (error) {
      console.error('Error fetching stock:', error);
      throw error;
    }
  },

  addStock: async (stockData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(stockData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to add stock');
      }
      return await response.json();
    } catch (error) {
      console.error('Error adding stock:', error);
      throw error;
    }
  },

  updateStock: async (id, stockData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(stockData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update stock');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating stock:', error);
      throw error;
    }
  },

  deleteStock: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete stock');
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting stock:', error);
      throw error;
    }
  },

  getStockBySize: async (size) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stock/by-size/${size}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch stocks by size');
      return await response.json();
    } catch (error) {
      console.error('Error fetching stocks by size:', error);
      throw error;
    }
  },
};

export default apiService;
